/* global GM_STATE */
import { useEffect, useState } from 'preact/hooks'

function Image({
  imageUrl = [GM_STATE.shopify.defaultImage],
  alt,
  className,
  imageClass,
  isLazy = true,
  isCover = true,
  imageSrcSet = [],
  imageBreakpoints = '(min-width: 0px)',
  key
}) {
  const [currentImageUrls] = useState(imageUrl)
  const classImage = `${isCover ? 'object-cover' : 'object-contain'} ${isLazy && 'lazyload'} ${imageClass}`
  const customClass = `relative ${className}`
  let fallbackImageUrl = currentImageUrls[0]
  let breakpoints = imageBreakpoints.includes('|') ? imageBreakpoints.split('|') : [imageBreakpoints]

  if (currentImageUrls.length <= 1) {
    breakpoints = breakpoints.splice(0, 1)
  } else {
    breakpoints = breakpoints.splice(0, currentImageUrls.length)
    fallbackImageUrl = currentImageUrls[currentImageUrls.length - 1]
  }

  useEffect(() => {
    if (window.lazySizes) {
      window.lazySizes.init()
    }
  }, [])

  const getSrcSet = (url) => {
    return imageSrcSet.length > 0 ? imageSrcSet.map((srcset) => `${url} ${srcset}w `).join(',') : url
  }

  return (
    <figure className={customClass} key={key}>
      <picture>
        {breakpoints.map((breakpoint, index) => (
          <source
            media={breakpoint}
            srcSet={isLazy ? undefined : getSrcSet(currentImageUrls[index])}
            data-srcset={isLazy ? getSrcSet(currentImageUrls[index]) : undefined}
          />
        ))}
        <img
          src={isLazy ? 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAA1JREFUCB1j+Pjx438ACX0D04PrXz0AAAAASUVORK5CYII=' : fallbackImageUrl}
          className={classImage}
          data-sizes='auto'
          data-src={isLazy ? fallbackImageUrl : undefined}
          alt={alt}
        />
      </picture>
    </figure>
  )
}

export default Image
